import GalleryPage from "@/components/GalleryPage";

const items = [
  {
    title: "Chair & Table Set",
    desc: "Handcrafted dining set from reclaimed timber",
    image: "https://customer-assets.emergentagent.com/job_green-creations/artifacts/kwc2gvb4_Small%20Feet%20chair%20and%20table%20set.avif",
    span: "md:col-span-8",
    height: "h-80 md:h-[28rem]",
  },
  {
    title: "Reclaimed Shelving",
    desc: "Rustic wall shelves with natural character",
    image: "https://customer-assets.emergentagent.com/job_green-creations/artifacts/b3om6iz0_Smal%20feet%20shelves.avif",
    span: "md:col-span-4",
    height: "h-80 md:h-[28rem]",
  },
  {
    title: "Garden Bench",
    desc: "Sturdy outdoor bench built to last",
    image: "https://customer-assets.emergentagent.com/job_green-creations/artifacts/n44u1js1_small%20feet%20garden%20bench.avif",
    span: "md:col-span-5",
    height: "h-72 md:h-96",
  },
  {
    title: "Bench Style Two",
    desc: "Contemporary take on reclaimed wood seating",
    image: "https://customer-assets.emergentagent.com/job_green-creations/artifacts/rsuu33nr_Small%20Feet%20bench%20style%202.avif",
    span: "md:col-span-7",
    height: "h-72 md:h-96",
  },
  {
    title: "Garden Furniture Set",
    desc: "Complete outdoor set crafted from salvaged wood",
    image: "https://customer-assets.emergentagent.com/job_green-creations/artifacts/4o3qmxat_Small%20feet%20garden%20funriture.avif",
    span: "md:col-span-7",
    height: "h-80 md:h-[26rem]",
  },
  {
    title: "Large Garden Corner",
    desc: "Bespoke corner seating for outdoor entertaining",
    image: "https://customer-assets.emergentagent.com/job_green-creations/artifacts/kvqpf96j_small%20feet%20large%20garden%20corner.avif",
    span: "md:col-span-5",
    height: "h-80 md:h-[26rem]",
  },
  {
    title: "Bus Furniture Build",
    desc: "Custom interior furniture for vehicle conversions",
    image: "https://customer-assets.emergentagent.com/job_green-creations/artifacts/ts3pt75h_small%20feet%20bus%20furniture.avif",
    span: "md:col-span-4",
    height: "h-72 md:h-96",
  },
  {
    title: "Large Hideaway",
    desc: "Spacious garden hideaway with reclaimed timber",
    image: "https://customer-assets.emergentagent.com/job_green-creations/artifacts/ipxhrxxy_small%20feet%20large%20hideaway.avif",
    span: "md:col-span-8",
    height: "h-72 md:h-96",
  },
  {
    title: "Table & Chairs",
    desc: "Outdoor dining set built from reclaimed wood",
    image: "https://customer-assets.emergentagent.com/job_green-creations/artifacts/kz539t1v_small%20feet%20table%20and%20chairs.avif",
    span: "md:col-span-7",
    height: "h-80 md:h-[26rem]",
  },
  {
    title: "Reclaimed Wardrobe",
    desc: "Freestanding wardrobe with rustic character",
    image: "https://customer-assets.emergentagent.com/job_green-creations/artifacts/8y8stcl1_small%20feet%20wardrobe%202.avif",
    span: "md:col-span-5",
    height: "h-80 md:h-[26rem]",
  },
  {
    title: "Outdoor Bench Set",
    desc: "Matching bench set for garden or patio",
    image: "https://customer-assets.emergentagent.com/job_green-creations/artifacts/vnyafdkx_small%20feet%20outdoor%20bench%20set.avif",
    span: "md:col-span-5",
    height: "h-72 md:h-96",
  },
  {
    title: "Reclaimed Table Top",
    desc: "Solid surface crafted from salvaged timber",
    image: "https://customer-assets.emergentagent.com/job_green-creations/artifacts/0hxt0ees_small%20feet%20reclaimed%20table%20top.avif",
    span: "md:col-span-7",
    height: "h-72 md:h-96",
  },
  {
    title: "Cafe Hideaway",
    desc: "Cosy cafe-style hideaway with reclaimed furnishings",
    image: "https://customer-assets.emergentagent.com/job_green-creations/artifacts/hn2klsiq_Cafe%20hideawaye.jpg.avif",
    span: "md:col-span-12",
    height: "h-[24rem] md:h-[36rem]",
    contain: true,
    containBg: "bg-[#EAE5D9]",
  },
];

export default function Furniture() {
  return (
    <GalleryPage
      testId="furniture-page"
      title="Furniture"
      subtitle="Tables you'll fight over at dinner, benches that make the garden look ace, and shelves with more personality than your average IKEA flatpack. Every scratch tells a story."
      items={items}
    />
  );
}
